// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_CancelaorcamentoservicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /orcamentos_servicos/cancelaOrcamentoServico
 *
 * Cancels an orcamento_servico via the servicos_handler interactor.
 *
 * Data shape: boolean true on success
 *
 * @see Orcamentos_servicos::cancelaOrcamentoServico()
 * @see Atendente_interactor::CancelaServicoOrcamento()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OrcamentosServicos_CancelaorcamentoservicoResponseDados = boolean;

export type OrcamentosServicos_CancelaorcamentoservicoResponse = ApiResponse<OrcamentosServicos_CancelaorcamentoservicoResponseDados>;

registerResponseContract('OrcamentosServicos_CancelaorcamentoservicoResponse', {})
